import { type AgentKnowledgeSource } from '@atlassian/conversation-assistant-service';

/**
 * We should update this list if we ever intend to support more knowledge sources in the future.
 */
export const allKnowledgeSources: AgentKnowledgeSource[] = [
	{
		source: 'confluence',
		configuration: { parent_filter: [], space_filter: [] },
		enabled: true,
	},
	{
		source: 'jira',
		configuration: { project_filter: [] },
		enabled: true,
	},
	{
		enabled: true,
		source: 'atlas',
		configuration: undefined,
	},
	{
		enabled: true,
		source: 'google_drive',
		configuration: undefined,
	},
	{
		enabled: true,
		source: 'microsoft_sharepoint',
		configuration: undefined,
	},
	{
		enabled: true,
		source: 'slack',
		configuration: undefined,
	},
];
